<template>
  <div class="post">
  <div class="post-header">
    <div class="profile" :style="`background-image:url(${포스팅.userImage})`"></div>
    <span class="profile-name">ChanKim</span>
  </div>
  
  <div v-on:click="like" :class="['post-body', 포스팅.filter]" :style="`background-image:url(${포스팅.postImage})`">
    <!-- <div class="heart">♥</div> -->
  </div>

  <div class="post-content">
    <p>{{임시라이크}} Likes</p>
    <p><strong>{{포스팅.name}}</strong> {{포스팅.caption}}</p>
    <p class="date">May 15</p>
  </div>
</div>

</template>

<script>
export default {
  data(){
    return {
      임시라이크 : this.포스팅.likes,
      liked : false
    }
  },
  props : {
    포스팅 : Object,
  }, 
  methods : {
    like(){
      if (this.liked == false){
        this.임시라이크++;
        this.liked = true;
      } else {
        this.임시라이크--;
        this.liked = false;
      }
    }
  }
}
</script>

<style>
.heart {
  font-size: 30px;
  margin: 200px auto;
}
.post {
width: 100%;
}
.profile {
background-image: url('https://placeimg.com/100/100/arch');
width: 30px;
height: 30px;
background-size: 100%;
border-radius: 50%;
float: left;
}
.profile-name {
display: block;
float: left;
padding-left: 10px;
padding-top: 7px;
font-size: 14px;
}
.post-header {
height: 30px;
padding: 10px;
}
.post-body {
  padding : 1px;
background-image: url('https://placeimg.com/640/480/animals');
height: 450px;
background-position: center;
background-size: cover;
}
.post-content {
padding-left: 15px;
padding-right: 15px;
font-size: 14px;
}
.date {
font-size: 11px;
color: grey;
margin-top: -8px;
}

</style>